export default "code.wasm"